export const FILTER_VALUE = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  TODAY: 'today',
  HEALTHY: 'healthy',
  ERROR: 'error',
} as const;

export const TIME_FRAME = {
  WEEK: '7days',
  MONTH: '30days',
  THREEMONTH: '90days',
  SIXMONTH: '180days',
  ONEYEAR: '365days',
} as const;

export type FilterValue = (typeof FILTER_VALUE)[keyof typeof FILTER_VALUE];
